import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useLeaderBoardJoin = () => {
    const send = useGenericSend();

    return useCallback(async ({ leaderboardId }: Types.ILeaderBoardJoinRequestData) => {
        const response = await send<Types.ILeaderBoardJoinRequestData, Types.ILeaderBoardJoinResponseData>({
            ID: 71004,
            leaderboardId,
            responses: [71005, 71006],
            description: 'Join to Leaderboard'
        });

        return response;
    }, [send]);
};
